var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transcript-switch"},[_c('switch-components',{attrs:{"component-list":_vm.componentList,"active-component":_vm.activeComponent},on:{"change-component":_vm.changeComponent}}),_c('transition',{attrs:{"name":"default","mode":"out-in"}},[_c(_vm.activeComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }